import { useQuery } from "@tanstack/react-query";
import adminApiClient, { CollectionAnalyticsResponse } from "api/admin";

export default function useCollectionAnalytics() {
  return useQuery<CollectionAnalyticsResponse>({
    queryKey: ["collectionAnalytics"],
    queryFn: () => adminApiClient.getCollectionAnalytics(),
  });
}
